import { ApiBankDetails, ApiBaseWorkerService, ApiGoogleCalendarItem, ApiWorkerDetails } from "@/api/worker/interface.api";
import { OrderFile, WorkerData, WorkerService } from "@/types";
import { useCallback, useEffect, useState } from "react";

import { BaseApiUser } from "@/api/user/interface.api";
import { WorkerDetails } from "#/pages";
import { useApi } from "@/api";
import { useNotes } from "@/hooks";
import { useParams } from 'react-router-dom';

const WorkerDetailsView = () => {
  const { id } = useParams<'id'>();
  const { account, user, session, worker } = useApi();

  const [loading, setloading] = useState(true);
  const [workerData, setWorkerData] = useState<WorkerData>();
  const [workerServices, setWorkerServices] = useState<WorkerService[]>([]);
  const [workerPortfolio, setWorkerPortfolio] = useState<OrderFile[]>([]);
  const { notes, onAddNote, setNotes } = useNotes();
  const [googleCalendarIds, setGoogleCalendarIds] = useState<ApiGoogleCalendarItem[]>();

  const workerId = id?.replace('id=', '') ?? session.user?.id ?? '';
  const isAdmin = session.user?.admin ?? false;

  const getData = async () => {
    const wor = await worker.getData(workerId);
    
    return wor;
  }
  const getServices = async () => {
    const wor = await worker.getServices(workerId);
    
    return wor;
  }
  const getPortfolio = async () => {
    const wor = await worker.getPortfolio(workerId);
    
    return wor;
  }

  const getNotes = async () => {
    const wor = await worker.getNotes(workerId);
    
    return wor;
  }

  const getCalendars = async () => {
    const wor = await worker.getCalendarList();

    return wor;
  }

  const loadData = async () => {
    setloading(true);

    getData().then(work => {
      setWorkerData(work);
    });

    getServices().then(work => {
      setWorkerServices(work);
    });

    getPortfolio().then(work => {
      setWorkerPortfolio(work);
    })

    getNotes().then(work => {
      setNotes(work);
    })

    if (!isAdmin) {
      getCalendars().then(work => {
        setGoogleCalendarIds(work);

      })
    }

    setloading(false);
  }

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    

    if (workerData && (googleCalendarIds?.length ?? 0) > 0 && !(workerData.workerDetails.googleCalendarId)) {

      worker.updateDetails(workerId, {
      AddressId: workerData.workerDetails.addressId,
      AddressString: workerData.workerDetails.addressString,
      Area: workerData.workerDetails.area,
      CommutingDistance: workerData.workerDetails.commutingDistance,
      CommutingDistanceType: workerData.workerDetails.commutingDistanceType,
      Country: workerData.workerDetails.county,
      DoorNumber: workerData.workerDetails.doorNumber,
      Flat: workerData.workerDetails.flat,
      FullTimeType: workerData.workerDetails.fullTimeType,
      GoogleCalendarId: googleCalendarIds?.[0].Id || '',
      HouseName: workerData.workerDetails.houseName,
      HouseNumber: workerData.workerDetails.houseNumber,
      Notes: workerData.workerDetails.notes,
      PhoneNumber: workerData.workerDetails.phoneNumber,
      PostCode: workerData.workerDetails.postCode,
      Rating: workerData.workerDetails.rating,
      Road: workerData.workerDetails.road,
      Town: workerData.workerDetails.town,
      WebsiteLink: workerData.workerDetails.websiteLink,
    }).then(loadData);
    }
  }, [workerData, googleCalendarIds])

  const handleSaveAccountDetails = useCallback(async (data: BaseApiUser) => {
    user.updateUser(data);
  }, []);

  const handleChangePassword = useCallback(async (oldPassword: string, newPassword: string, confirmPassword: string ) => {
    await account.changePassword(workerId, oldPassword, newPassword, confirmPassword);
  }, []);

  const handleSaveDetails = useCallback(async (data: ApiWorkerDetails) => {
    await worker.updateDetails(workerId, data);
  }, []);

  const handleSaveServices = useCallback(async (data: ApiBaseWorkerService[]) => {
    await worker.updateServices(workerId, data);
  }, []);

  const handleUpdateBankDetails = useCallback(async (data: ApiBankDetails) => {
    await worker.updateBankDetails(workerId, data);
  }, []);

  const handleLinkCalendar = useCallback(async () => {
    await worker.redirectSyncGoogleAccount();
  }, []);

  const handleUnlinkCalendar = useCallback(async () => {
    await worker.unlinkGoogleCalendar();
    await loadData();
  }, []);

  const handleCancelNote = async () => {
    setNotes(notes.slice(0, -1));
  };

  const handleSaveNote = useCallback(async (noteContent: string) => {
    const lastNote = notes[notes.length - 1];
    lastNote.content = noteContent;
    lastNote.created = new Date().toISOString();
    worker.addNote(Number(workerData?.workerId), noteContent);
    setNotes([...notes.slice(0, -1), lastNote]);
  }, [workerData, workerData?.workerId, notes]);

  const handleAddPostCode = async(code: string) => {
     await worker.addPostcode(workerData?.workerId || 0 ,code);
     getData().then(work => {
      setWorkerData(work);
    });
  }

  const handleDeletePostCode = async (workerPostCodeId: string) => {
    await worker.deletePostcode(workerPostCodeId);
     getData().then(work => {
      setWorkerData(work);
    });
  }

  return (
    <>
      {!loading && workerData && workerServices && workerPortfolio && notes && <WorkerDetails
        googleCalendarIds={googleCalendarIds || []}
        isAdmin={isAdmin}
        notes={notes}
        onAddNote={onAddNote}
        onAddPostCode={handleAddPostCode}
        onDeletePostCode={handleDeletePostCode}
        onCancelNote={handleCancelNote}
        onSaveNote={handleSaveNote}
        onChangePassword={handleChangePassword}
        onSaveAccountDetails={handleSaveAccountDetails}
        onSaveDetails={handleSaveDetails}
        onSaveServices={handleSaveServices}
        onSaveBankDetails={handleUpdateBankDetails}
        onLinkGoogleCalendar={handleLinkCalendar}
        onUnlinkGoogleCalendar={handleUnlinkCalendar}
        owner={`${session.user?.firstName} ${session.user?.lastName}`}
        workerData={workerData}
        workerId={workerId}
        workerPortfolio={workerPortfolio}
        workerServices={workerServices} /> }

    </>
  );
}

export default WorkerDetailsView;